export const PAGE_SIZE = 50;

export const formatNumber = (value) =>
  value == null || Number.isNaN(Number(value)) ? '—' : Number(value).toLocaleString('en-IN');

export const formatFe = (value) => (value == null ? '—' : `${formatNumber(value)} FE`);

export const formatSeasonLabel = (season) => {
  if (!season) return null;
  const label = season.seasonNumber != null ? `Season #${season.seasonNumber}` : 'Season';
  const range =
    season.startDate && season.endDate ? `${season.startDate} → ${season.endDate}` : null;
  const current = season.isCurrent ? ' (current)' : '';
  return range ? `${label} · ${range}${current}` : `${label}${current}`;
};

export const getTodayIst = () =>
  new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Kolkata' }).format(new Date());
